import React, { Fragment } from 'react';
import { IConfirmDialog } from './interfaces';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../Dialog';
import { Button } from '../Dialog/components/Button';

export const ConfirmDialog: React.FC<IConfirmDialog> = ({
  title,
  subTitle,
  children,
  show,
  confirmLabel,
  confirmVariant = 'primary',
  disabled = false,
  confirmDisabled = false,
  onClose,
  onConfirm,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog
      show={show}
      title={title}
      subTitle={subTitle}
      onClose={onClose}
      buttons={
        <Fragment>
          <Button
            onClick={onClose}
            disabled={disabled}
            label={t('buttons.cancel')}
          />
          <Button
            onClick={onConfirm}
            disabled={disabled || confirmDisabled}
            variant={confirmVariant}
            label={confirmLabel || t('buttons.ok')}
          />
        </Fragment>
      }
    >
      {children}
    </Dialog>
  );
};
